import { SessionService } from '../SessionService';
import { CarouselItemDtoToCarouselItemConverter } from './CarouselItemDtoToCarouselItemConverter';
import { ContactUsConfigDtoToContactUsConfigConverter } from './ContactUsConfigDtoToContactUsConfigConverter';
export class DatAppConfigDtoToDatAppConfigConverter {
    carouselItemConverter;
    contactUsConfigConverter;
    static TO_BE_CONFIGURED = 'To Be Configured';
    static DEFAULT_HERO_LABEL_COLOR = '#fffff';
    static DEFAULT_MINOR_AGE_EXPIRATION = 18;
    constructor(carouselItemConverter, contactUsConfigConverter) {
        this.carouselItemConverter = carouselItemConverter;
        this.contactUsConfigConverter = contactUsConfigConverter;
    }
    static create = () => {
        return new DatAppConfigDtoToDatAppConfigConverter(CarouselItemDtoToCarouselItemConverter.create(), ContactUsConfigDtoToContactUsConfigConverter.create());
    };
    toModel = (source) => {
        return {
            hero: source.heroImage
                ? source.heroImage
                : {
                    label: {
                        text: DatAppConfigDtoToDatAppConfigConverter.TO_BE_CONFIGURED,
                        color: DatAppConfigDtoToDatAppConfigConverter.DEFAULT_HERO_LABEL_COLOR,
                    },
                },
            theme: source.theme,
            supportedStates: source.supportedStates ?? [],
            residenceMsg: source.residenceMsg ?? DatAppConfigDtoToDatAppConfigConverter.TO_BE_CONFIGURED,
            feesMsg: source.feesMsg,
            enabled: source.enabled ?? false,
            labLocationSubHeader: source.labLocationSubHeader ?? DatAppConfigDtoToDatAppConfigConverter.TO_BE_CONFIGURED,
            reviewingResults: source.reviewingResults ?? DatAppConfigDtoToDatAppConfigConverter.TO_BE_CONFIGURED,
            cancellationPolicy: source.cancellationPolicy ?? DatAppConfigDtoToDatAppConfigConverter.TO_BE_CONFIGURED,
            expirationPolicy: source.expirationPolicy ?? DatAppConfigDtoToDatAppConfigConverter.TO_BE_CONFIGURED,
            nonRefundableFee: source.nonRefundableFee ?? 0,
            inactivityTimeoutIntervalInMs: source.inactivityTimeoutIntervalInMs ?? SessionService.DEFAULT_TIME_OUT_INTERVAL,
            inactivityWarningIntervalInMs: source.inactivityWarningIntervalInMs ?? SessionService.DEFAULT_TIME_OUT_WARNING_INTERVAL,
            signInAlreadyHaveAnAccountHeader: source.signInAlreadyHaveAnAccountHeader ?? SessionService.DEFAULT_SIGN_IN_ALREADY_HAVE_ACCOUNT_HEADER,
            signInLoginHeader: source.signInLoginHeader ?? SessionService.DEFAULT_SIGN_IN_LOGIN_HEADER,
            carouselItems: source.carouselItems ? source.carouselItems.map((item) => this.carouselItemConverter.toModel(item)) : [],
            contactUsConfig: source.contactUs ? this.contactUsConfigConverter.toModel(source.contactUs) : undefined,
            userInitiatedOrderCancellationEnabled: source.userInitiatedOrderCancellationEnabled,
            serviceAreasEnabled: source.serviceAreasEnabled ?? false,
            guestCheckoutEnabled: source.guestCheckoutEnabled ?? false,
            checkoutFeeLabel: source.checkoutFeeLabel ?? 'Fees',
            checkoutFeeInPennies: source.checkoutFeeInPennies ?? 0,
            genders: source.genders ?? {},
            privacyPolicyUrl: source.privacyPolicyUrl,
            privacyPolicyLabel: source.privacyPolicyLabel ?? 'Privacy Policy',
            termsOfServiceUrl: source.termsOfServiceUrl,
            termsOfServiceLabel: source.termsOfServiceLabel ?? 'Terms of Service',
            customLabLocationsUrl: source.customLabLocationsUrl,
            hideAddressOnPdfEnabled: source.hideAddressOnPdfEnabled ?? false,
            bannerGradientEnabled: source.bannerGradientEnabled ?? false,
            viewResultsUrl: source.viewResultsUrl,
            minorSupportEnabled: source.minorSupportEnabled ?? false,
            minorAgeExpiration: source.minorAgeExpiration ?? DatAppConfigDtoToDatAppConfigConverter.DEFAULT_MINOR_AGE_EXPIRATION,
            bundleCodeEnabled: source.bundleCodeEnabled,
            hideIncludedTestsEnabled: source.hideIncludedTestsEnabled,
            minorRegistrationHeader: source.minorRegistrationHeader,
            guardianSwitchLabel: source.guardianSwitchLabel,
            signupRelationshipEnabled: source.signupRelationshipEnabled ?? false,
            enableLast4Collection: source.enableLast4Collection ?? true,
            categoriesInMenuOnlyEnabled: source.categoriesInMenuOnlyEnabled ?? false,
        };
    };
}
